/* zt-subscribe-deploy:1786473100 already-copy */
(function () {
  // Public Site ID only. Never put a private Klaviyo key in theme JS.
  var KLAVIYO_COMPANY_ID = "XzBHnt";
  var KLAVIYO_LIST_ID = "THsrda";
  var KLAVIYO_REVISION = "2024-10-15";

  // Industry-typical: delay once, then cool off for weeks; never after subscribe.
  var DISMISS_KEY = "zt_subscribe_dismissed_v4";
  var SUBSCRIBED_KEY = "zt_subscribed";
  var SUBSCRIBED_KEY_LEGACY = "zt_subscribe_joined_v1";
  var SESSION_KEY = "zt_subscribe_shown_session";
  var AUTO_OPEN_MS = 9000;
  var DISMISS_DAYS = 30;

  function bootSubscribe() {
    var overlay = document.getElementById("zt-subscribe-overlay");
    if (!overlay) return;

    var modal = overlay.querySelector(".zt-subscribe-modal");
    var form = document.getElementById("zt-subscribe-form");
    var emailInput = document.getElementById("zt-subscribe-email");
    var note = document.getElementById("zt-subscribe-note");
    var title = document.getElementById("zt-subscribe-title");
    var copy = document.getElementById("zt-subscribe-copy");
    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    var lastFocus = null;
    var autoTimer = null;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function storageSet(key, val) {
      try {
        window.localStorage.setItem(key, val);
      } catch (e) {}
    }

    function sessionGet(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function sessionSet(key, val) {
      try {
        window.sessionStorage.setItem(key, val);
      } catch (e) {}
    }

    function alreadyJoined() {
      return Boolean(storageGet(SUBSCRIBED_KEY) || storageGet(SUBSCRIBED_KEY_LEGACY));
    }

    function isCustomerLoggedIn() {
      if (window.__ztCustomerLoggedIn === true) return true;
      return overlay.getAttribute("data-customer-logged-in") === "true";
    }

    function isSubscribed() {
      return alreadyJoined() || isCustomerLoggedIn();
    }

    function wasDismissed() {
      var raw = storageGet(DISMISS_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!ts) return true;
      return Date.now() - ts < DISMISS_DAYS * 24 * 60 * 60 * 1000;
    }

    function shownThisSession() {
      return Boolean(sessionGet(SESSION_KEY));
    }

    function markDismissed() {
      storageSet(DISMISS_KEY, String(Date.now()));
      sessionSet(SESSION_KEY, "1");
    }

    function markJoined() {
      storageSet(SUBSCRIBED_KEY, "1");
      storageSet(SUBSCRIBED_KEY_LEGACY, "1");
      markDismissed();
    }

    function clearNote() {
      if (!note) return;
      note.hidden = true;
      note.textContent = "";
    }

    function setNote(text) {
      if (!note) return;
      note.hidden = !text;
      note.textContent = text || "";
    }

    function showForm(show) {
      if (!form) return;
      form.hidden = !show;
      form.style.display = show ? "" : "none";
      form.setAttribute("aria-hidden", show ? "false" : "true");
      if (emailInput) {
        if (show) emailInput.removeAttribute("tabindex");
        else emailInput.setAttribute("tabindex", "-1");
      }
      if (submitBtn) {
        if (show) submitBtn.removeAttribute("tabindex");
        else submitBtn.setAttribute("tabindex", "-1");
      }
    }

    function showCapture() {
      overlay.classList.remove("is-success", "is-already");
      if (title) {
        title.textContent =
          (modal && modal.getAttribute("data-capture-title")) || "You've got 15% off";
      }
      if (copy) {
        copy.textContent =
          (modal && modal.getAttribute("data-capture-copy")) ||
          "Join the newsletter — new drops and the quiet work. No spam.";
      }
      showForm(true);
      clearNote();
      window.setTimeout(function () {
        if (emailInput) emailInput.focus();
      }, 0);
    }

    function showAlreadySubscribed() {
      overlay.classList.remove("is-success");
      overlay.classList.add("is-already");
      showForm(false);
      if (emailInput) {
        emailInput.blur();
        emailInput.value = "";
      }
      if (title) {
        title.textContent =
          (modal && modal.getAttribute("data-already-title")) || "You're on the list";
      }
      if (copy) {
        copy.textContent =
          (modal && modal.getAttribute("data-already-copy")) ||
          "You're already subscribed. New drops land in your inbox.";
      }
      setNote("");
      // Focus close so tab trap doesn't land on a hidden form control.
      var closeBtn = overlay.querySelector("[data-close-subscribe]");
      if (closeBtn && typeof closeBtn.focus === "function") {
        window.setTimeout(function () {
          closeBtn.focus();
        }, 0);
      }
    }

    function openSubscribe() {
      if (!overlay.hidden) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add("zt-subscribe-open");
      sessionSet(SESSION_KEY, "1");

      if (isSubscribed()) {
        // Persist for return visits when Shopify session is the signal.
        if (isCustomerLoggedIn() && !alreadyJoined()) markJoined();
        showAlreadySubscribed();
        return;
      }

      showCapture();
    }

    function closeSubscribe() {
      overlay.hidden = true;
      document.body.classList.remove("zt-subscribe-open");
      if (!alreadyJoined()) markDismissed();
      if (autoTimer) {
        window.clearTimeout(autoTimer);
        autoTimer = null;
      }
      if (lastFocus && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
    }

    document.querySelectorAll("[data-open-subscribe]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        openSubscribe();
      });
    });

    document.querySelectorAll("[data-close-subscribe]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        closeSubscribe();
      });
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeSubscribe();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.hidden) {
        e.preventDefault();
        closeSubscribe();
        return;
      }
      if (e.key !== "Tab" || overlay.hidden) return;
      var focusable = overlay.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    function showSuccess() {
      overlay.classList.remove("is-already");
      overlay.classList.add("is-success");
      showForm(false);
      if (title) title.textContent = "You're in";
      if (copy) {
        copy.innerHTML =
          'Your code is <span class="zt-subscribe-code">DOSE</span> · 15% once. We also sent it to your inbox.';
      }
      setNote("Use it at checkout whenever you're ready.");
      if (form) form.reset();
      markJoined();
    }

    function showError(message) {
      setNote(message || "Something went wrong. Try again, or email info@zonetwo.co.");
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = String((emailInput && emailInput.value) || "")
          .trim()
          .toLowerCase();
        if (!email) return;

        if (submitBtn) {
          submitBtn.disabled = true;
        }
        clearNote();

        var payload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: KLAVIYO_LIST_ID,
                },
              },
            },
          },
        };

        fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" +
            encodeURIComponent(KLAVIYO_COMPANY_ID),
          {
            method: "POST",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify(payload),
          }
        )
          .then(function (res) {
            if (res.status === 202 || res.ok) {
              window._learnq = window._learnq || [];
              window._learnq.push(["identify", { $email: email }]);
              showSuccess();
              return;
            }
            return res.text().then(function () {
              showError();
            });
          })
          .catch(function () {
            showError();
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }

    // Logged-in customers: treat as subscribed for auto-popup + click behavior.
    if (isCustomerLoggedIn() && !alreadyJoined()) {
      markJoined();
    }

    var path = (window.location && window.location.pathname) || "";
    var skipAuto =
      path.indexOf("/account") === 0 ||
      path.indexOf("/checkouts") === 0 ||
      path.indexOf("/challenge") === 0 ||
      path.indexOf("/cart") === 0;

    // Once per session, only if not subscribed and not dismissed in last 30 days.
    if (!skipAuto && !isSubscribed() && !wasDismissed() && !shownThisSession()) {
      autoTimer = window.setTimeout(openSubscribe, AUTO_OPEN_MS);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootSubscribe);
  } else {
    bootSubscribe();
  }
})();
